import {
  Box,
  Button,
  Center,
  CloseButton,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { ChangeEvent, FC, useRef, useState } from 'react';
import { useGetTeamsByInfo } from '@frx/frx-react-context';
import { Team } from '@frx/frx-services';
import { Modal, PaginationList } from '../../../../components';
import { Search, Volunteer } from '../../../../assets';
import { useEventId } from '../../../../hooks';
import { TeamRecord } from './TeamRecord';
import { getDataTracking } from '../../../../utils';

export const JoinTeamModal: FC = () => {
  const searchRef = useRef<HTMLInputElement>(null);
  const [filteredTeams, setFilteredTeams] = useState<Team[]>();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const eventId = useEventId();
  const teamsData = useGetTeamsByInfo({
    fr_id: eventId,
    list_page_size: 2000,
    list_sort_column: 'name',
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.currentTarget.value.toLowerCase();
    setFilteredTeams(
      teamsData.data?.team?.filter(
        (team) =>
          String(team?.name)?.toLowerCase()?.indexOf(query) >= 0 ||
          String(team?.captainFirstName)?.toLowerCase()?.indexOf(query) >= 0 ||
          String(team?.captainLastName)?.toLowerCase()?.indexOf(query) >= 0 ||
          String(team?.companyName)?.toLowerCase()?.indexOf(query) >= 0
      )
    );
  };

  const handleClearInput = () => {
    setFilteredTeams(undefined);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    searchRef.current.value = '';
  };

  return (
    <>
      <Button
        w="full"
        height="143px"
        colorScheme="blue"
        variant="secondary"
        onClick={onOpen}
        {...getDataTracking('joinTeamButton')}
      >
        <VStack>
          <Center>
            <Icon as={Volunteer} boxSize="64px" />
          </Center>
          <Center>Join a Team</Center>
        </VStack>
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <Box>
          <HStack>
            <Icon as={Search} />
            <Text fontSize="lg" fontWeight="bold">
              Search Teams
            </Text>
          </HStack>
          <Text
            fontSize="sm"
            color="brand.monochromatic.500"
            fontWeight="bold"
            pb={2}
          >
            Search team name, captain, and company
          </Text>
          <InputGroup>
            <Input
              ref={searchRef}
              id="searchTeams"
              onChange={handleChange}
              aria-label="Search Teams"
            />
            <InputRightElement>
              <CloseButton
                size="sm"
                onClick={handleClearInput}
                {...getDataTracking('searchTeamInputClear')}
              />
            </InputRightElement>
          </InputGroup>
        </Box>
        <Box px={4} py={6}>
          <PaginationList
            listItems={filteredTeams ?? (teamsData.data?.team as Team[])}
          >
            <TeamRecord onClose={onClose} />
          </PaginationList>
        </Box>
      </Modal>
    </>
  );
};
